// extracted by mini-css-extract-plugin
var _1 = "Counter-modulecounter__yXwqU";
var _2 = "Counter-moduleerror__bCoHi";
var _3 = "Counter-moduletable__yR0uS";
var _4 = "Counter-moduletheme__ni4VE";
export { _1 as "counter", _2 as "error", _3 as "table", _4 as "theme" }
